module.exports = __webpack_public_path__ + "img/843-dede69.png";